import { render } from "./BaseControls.vue?vue&type=template&id=74dea9c3"
import script from "./BaseControls.vue?vue&type=script&lang=js"
export * from "./BaseControls.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ricpp/Development/boldbrush/blog_post_editor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__